export default {
  meta: {
    title: '加盟商管理',
    url: '/fishtogether/expandtaskmng', // 埋点用，记录所属模块
  },
};
